// extracted by mini-css-extract-plugin
module.exports = {"filter":"filter-module--filter--3bYPp"};